import { SkuCutoversContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

const SkuCutoversPage = () => {
  return (
    <PageFrame>
      <SkuCutoversContainer />
    </PageFrame>
  );
};

export default SkuCutoversPage;
